'use strict';

const libPictView = require('pict-view');

/**
 * SampleQRCodeConfig view — the shell for the bespoke #/SampleQRCodeConfig screen. Thin host: paints the header +
 * a single #SQR-Detail mount and hands rendering to the SampleQRCodeConfig provider (self-loads on first render).
 */
class SampleQRCodeConfig extends libPictView
{
	get provider() { return this.pict.providers.SampleQRCodeConfig; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider.render();
			if (!tmpProvider.state.Loaded && !tmpProvider.state.Loading) { tmpProvider.loadAsync(); }
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = SampleQRCodeConfig;
module.exports.default_configuration =
{
	ViewIdentifier: 'SampleQRCodeConfig',
	DefaultRenderable: 'SampleQRCodeConfigWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: /*css*/`
		.sqr-wrap { padding: 1.25rem 1.5rem 2rem; }
		.sqr-head { margin: 0 0 1rem; }
		.sqr-title { font-size:1.5rem; font-weight:700; line-height:1.2; margin:0; color:var(--theme-color-text-primary,#1f2733); }
		.sqr-subtitle { font-size:0.9rem; color:var(--theme-color-text-muted,#6b7686); margin:0.2rem 0 0; }
		.sqr-main { border:1px solid var(--theme-color-border-default,#d7dce3); border-radius:8px; background:var(--theme-color-background-panel,#fff); padding:1.1rem 1.25rem; min-height:18rem; max-width:44rem; }
		.sqr-empty { display:flex; align-items:center; justify-content:center; text-align:center; min-height:12rem; color:var(--theme-color-text-muted,#6b7686); gap:0.5rem; }
		.sqr-field { margin:0 0 1rem; }
		.sqr-field-label { display:block; font-size:0.66rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#6b7686); margin:0 0 0.35rem; }
		.sqr-select { font-size:0.9rem; padding:0.42rem 0.6rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:7px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); min-width:20rem; max-width:100%; }
		.sqr-customer { font-size:0.98rem; font-weight:600; color:var(--theme-color-text-primary,#1f2733); }
		.sqr-options { display:flex; flex-direction:column; gap:0.7rem; margin:0.2rem 0 1rem; }
		.sqr-option { display:flex; gap:0.75rem; align-items:flex-start; padding:0.85rem 1rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:9px; cursor:pointer; background:var(--theme-color-background-panel,#fff); }
		.sqr-option.is-active { border-color:var(--theme-color-brand-primary,#5650e6); box-shadow:0 0 0 1px var(--theme-color-brand-primary,#5650e6); background:var(--theme-color-background-selected,#f5f5fe); }
		.sqr-option input { margin-top:0.2rem; flex:0 0 auto; }
		.sqr-option-body { flex:1 1 auto; min-width:0; }
		.sqr-option-title { font-size:0.98rem; font-weight:650; color:var(--theme-color-text-primary,#1f2733); }
		.sqr-option-desc { font-size:0.84rem; color:var(--theme-color-text-muted,#6b7686); margin:0.15rem 0 0.4rem; }
		.sqr-option-preview { font-size:0.82rem; color:var(--theme-color-text-secondary,#45505f); display:flex; align-items:center; gap:0.5rem; }
		.sqr-preview-label { font-size:0.62rem; font-weight:700; text-transform:uppercase; letter-spacing:0.05em; color:var(--theme-color-text-muted,#8894a4); }
		.sqr-option-preview code { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; font-size:0.86rem; background:var(--theme-color-background-tertiary,#f0f2f6); padding:0.12rem 0.45rem; border-radius:5px; color:var(--theme-color-text-primary,#1f2733); }
		.sqr-note { font-size:0.82rem; color:var(--theme-color-text-muted,#6b7686); background:var(--theme-color-background-secondary,#f7f9fb); border-radius:7px; padding:0.6rem 0.75rem; margin:0 0 1rem; }
		.sqr-note code { font-family:ui-monospace,SFMono-Regular,Menlo,monospace; }
		.sqr-savebar { margin-top:0.5rem; }
		.sqr-save { font-size:0.9rem; font-weight:600; padding:0.5rem 1.2rem; border-radius:7px; border:1px solid var(--theme-color-brand-primary,#5650e6); background:var(--theme-color-brand-primary,#5650e6); color:#fff; cursor:pointer; }
		.sqr-save[disabled] { opacity:0.6; cursor:default; }
		.sqr-msg { font-size:0.85rem; color:var(--theme-color-status-success,#1f7a4d); background:var(--theme-color-background-tertiary,#f0f7f2); border-radius:6px; padding:0.45rem 0.7rem; margin:0 0 0.9rem; }
		.sqr-error { font-size:0.85rem; color:var(--theme-color-status-danger,#c0392b); margin:0 0 0.9rem; }
		.sqr-tabs { display:flex; gap:0.25rem; border-bottom:1px solid var(--theme-color-border-light,#eef1f6); margin:0.2rem 0 1rem; }
		.sqr-tab { font-size:0.88rem; font-weight:600; padding:0.45rem 0.95rem; border:none; background:transparent; color:var(--theme-color-text-muted,#6b7686); cursor:pointer; border-bottom:2px solid transparent; margin-bottom:-1px; }
		.sqr-tab:hover { color:var(--theme-color-text-primary,#1f2733); }
		.sqr-tab.is-active { color:var(--theme-color-brand-primary,#5650e6); border-bottom-color:var(--theme-color-brand-primary,#5650e6); }
		.sqr-input { font-size:0.86rem; padding:0.38rem 0.55rem; border:1px solid var(--theme-color-border-medium,#d5dbe3); border-radius:6px; background:var(--theme-color-background-input,#fff); color:var(--theme-color-text-primary,#1f2733); box-sizing:border-box; }
		.sqr-styletoggle { display:flex; gap:0.4rem; }
		.sqr-stylebtn { font-size:0.84rem; font-weight:600; padding:0.35rem 0.85rem; border-radius:7px; border:1px solid var(--theme-color-border-medium,#d5dbe3); background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.sqr-stylebtn.is-active { background:var(--theme-color-brand-primary,#5650e6); border-color:var(--theme-color-brand-primary,#5650e6); color:#fff; }
		.sqr-fields { display:flex; flex-direction:column; gap:0.4rem; }
		.sqr-fieldrow { display:flex; align-items:center; gap:0.5rem; }
		.sqr-fieldkey { flex:0 0 11rem; font-size:0.8rem; font-family:ui-monospace,SFMono-Regular,Menlo,monospace; color:var(--theme-color-text-secondary,#45505f); overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
		.sqr-fieldname { flex:1 1 auto; min-width:0; }
		.sqr-rc { display:flex; align-items:center; gap:0.3rem; font-size:0.74rem; color:var(--theme-color-text-muted,#8894a4); flex:0 0 auto; }
		.sqr-rcnum { width:3.2rem; }
		.sqr-datefmt { flex:0 0 auto; width:auto; }
		.sqr-fieldremove { flex:0 0 auto; width:1.9rem; height:1.9rem; border:1px solid var(--theme-color-border-light,#e6eaf0); border-radius:6px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-muted,#a0a8b4); cursor:pointer; }
		.sqr-fieldremove:hover { color:var(--theme-color-status-danger,#c0392b); border-color:var(--theme-color-status-danger,#c0392b); }
		.sqr-availwrap { display:flex; flex-wrap:wrap; gap:0.4rem; }
		.sqr-avail { font-size:0.8rem; padding:0.28rem 0.6rem; border:1px dashed var(--theme-color-border-medium,#d5dbe3); border-radius:999px; background:var(--theme-color-background-panel,#fff); color:var(--theme-color-text-secondary,#45505f); cursor:pointer; }
		.sqr-avail:hover { border-color:var(--theme-color-brand-primary,#5650e6); color:var(--theme-color-brand-primary,#5650e6); }
		.sqr-avail-empty { font-size:0.84rem; color:var(--theme-color-text-muted,#8894a4); }
		.sqr-preview-wrap { margin:1.1rem 0 0.6rem; }
		.sqr-preview { border:1px dashed var(--theme-color-border-medium,#d5dbe3); border-radius:8px; padding:0.8rem; min-height:5rem; background:var(--theme-color-background-tertiary,#f7f9fb); display:flex; align-items:center; justify-content:center; overflow:auto; }
		.sqr-preview-empty { font-size:0.84rem; color:var(--theme-color-text-muted,#8894a4); }
	`,
	Templates:
	[
		{
			Hash: 'SampleQRCodeConfig-Wrap',
			Template: /*html*/`
				<div class="sqr-wrap">
					<div class="sqr-head">
						<h1 class="sqr-title">Sample QR Codes</h1>
						<p class="sqr-subtitle">Choose how new sample QR codes are generated for a customer. This affects only samples created from now on; existing QR codes are unchanged.</p>
					</div>
					<div id="SQR-Detail" class="sqr-main"></div>
				</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'SampleQRCodeConfigWrap',
			TemplateHash: 'SampleQRCodeConfig-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
